class NetworkError extends Error {
    status;
    constructor(message = 'Something went wrong. Please try again', status = 500) {
        super();
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, this.constructor);
        }
        this.name = this.constructor.name;
        this.message = message;
        this.status = status;
    }
    toJSON() {
        return {
            status: this.status,
            message: this.message,
        };
    }
}

export { NetworkError };
//# sourceMappingURL=NetworkError.js.map
